import { type ReactNode, useEffect, useState } from 'react'
import { api } from '../lib/api'
import { useI18n } from '../i18n'

export function SessionBootstrap({ children }: { children: ReactNode }) {
  const { t } = useI18n()
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const controller = new AbortController()
    api.session(controller.signal)
      .catch(() => undefined)
      .finally(() => {
        if (!controller.signal.aborted) setReady(true)
      })
    return () => controller.abort()
  }, [])

  if (!ready) {
    return (
      <div className="grid min-h-screen place-items-center bg-paper text-xs text-ink/40">
        {t('loading.session')}
      </div>
    )
  }
  return children
}
